import { createContext } from "react";

export default createContext({} as GlobalContext);

type GlobalContext = {
  loggedIn: boolean;
  setLoggedIn: (loggedIn: boolean) => void;
  currency: string;
  setCurrency: (currency: string) => void;
};
